import { render, staticRenderFns } from "./CouponsMessage.vue?vue&type=template&id=e5b31e84&scoped=true&"
import script from "./CouponsMessage.vue?vue&type=script&lang=js&"
export * from "./CouponsMessage.vue?vue&type=script&lang=js&"
import style0 from "./CouponsMessage.vue?vue&type=style&index=0&id=e5b31e84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b31e84",
  null
  
)

export default component.exports